<template>

  <div class="equipments">

  	<!-- page-heading -->
  	<page-heading :show="true" pageTitle="EQUIPMENTS-ADS"></page-heading>

  	<div class="columns">

  		<div class="col-main">

  			<!-- show loading indicator -->
  			<loading-indicator :loading="isLoading"></loading-indicator>

  			<template v-if="!isLoading">

          <v-client-table ref="tbl" name="tbl" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tbl noFirstColumn">

  					<!-- image -->
  					<template slot="asset" slot-scope="props">
  						<!-- <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImagePath(props.row.asset)" :key="props.row.id"></div> -->

              <lightbox :src="getImagePath(props.row.asset)" class="has-pointer" :key="props.row.id">
                  <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImagePath(props.row.asset)"></div>
              </lightbox>

  					</template>

            <!-- active/inactive -->
            <template slot="status" slot-scope="props">
              <b-switch v-model="props.row.isActive" type="primary" size="small" @click.native="changeStatusAd(props.row)" :disabled="props.row.isLoading" :key="props.row.id"></b-switch>
            </template>

  					<!-- delete -->
  					<template slot="actions" slot-scope="props">

              <!--
              <pop-confirm class="has-pointer" title="Anzeige löschen" content="Sind Sie sicher, dass Sie diese Anzeige löschen wollen?" icon="question-circle-o" :on-ok="function() { deleteAd(props.row) }" cancel-text="nein" ok-text="löschen">
                <span class="icon is-small">
                  <i class="icon-ak-entfernen"></i>
                </span>
              </pop-confirm>
            -->

              <span class="icon is-small" @click="deleteAd(props.row)">
                <i class="icon-ak-entfernen"></i>
              </span>

  					</template>

  				</v-client-table>
  			</template>

  		</div>


  		<div class="col-aside">

  			<affix :offset="50">

  				<div class="sidebox">
            <custom-button type="blue" name="IP-BTN-AD_ADD" icon="icon-ak-hinzufuegen" @click.native="uploadAd"></custom-button>
  				</div>

  			</affix>

  		</div>

  	</div>


    <!-- MODAL WINDOW -->
    <modal
      :title="modal.title"
      transition="zoom"
      cancel-text="abbrechen"
      :show-ok="false"
      :backdrop-closable="false"
      :is-show="showModal"
      @close="closeModal"
      :class="modal.class">

      <!-- UPLOAD IMAGES -->
      <template v-if="modal.type=='upload'">

        <div slot="header">
            <div class="modal-card-title" style="display: inline-block; margin-right: 10px;">{{ modal.title }}</div>
        </div>

        <vue-dropzone
            ref="dzImagePool"
            id="dzImagePool"
            url="fileProcessing/upload?preset=equipmentCatalogAd"
            :maxFiles="1"
            :thumbnailWidth="100"
            :thumbnailHeight="200"
            maxFilesize="256"
            acceptedFiles= ".jpg,.jpeg,.png,.gif"
            dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Bild hochladen"
            v-on:vdropzone-success="uploadAdSuccess">
        </vue-dropzone>


        <div slot="footer">
          <span class="button" @click="closeModal">schließen</span>
          <template v-if="uploadedAds.length > 0">
              <span :class="['button is-success', { 'is-loading': modalIsSaving }]" @click="uploadedImagesOK">speichern</span>
          </template>
        </div>

      </template>

    </modal>

  </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import vue2Dropzone from '../utils/dropzoneWrapper'

export default {

	name: 'equipmentCatalogAds',

	components: {
		vueDropzone: vue2Dropzone,
	},

	data() {

		var self = this;

		return {
			isLoading: false,

      uploadedAds: [],

      modal: {
          type: null,
          title: "",
          class: "",
          isLoading: false
      },
      showModal: false,
      modalIsSaving: false,

			table: {

				tblColumns: [
          'asset',
          // 'name',
          'status',
          'actions'
        ],

				tblData: [],

				tblOptions: {
					trackBy: 'id',
          uniqueKey: 'id',
					saveState: true,
					perPage: 25,
					orderBy: {
						ascending: true,
						column: 'name'
					},

          // custom table headings - make them clickable for language Setting
					headings: {

						asset: function(h) {
							return <lang labelKey="EQUIPMENTS_ADS_TBL_HEADER-IMAGE"></lang>
						},
						name: function(h) {
							return <lang labelKey="EQUIPMENTS_ADS_TBL_HEADER-NAME"></lang>
						},
            status: function(h) {
							return <lang labelKey="EQUIPMENTS_ADS_TBL_HEADER-STATUS"></lang>
						},
						actions: function(h) {
              return <lang labelKey="EQUIPMENTS_ADS_TBL_HEADER-ACTIONS"></lang>
            },
					},

					sortable: ['name', 'extRef'],
					sortIcon: {
              base:'fa',
              up:'fa-sort-up',
              down:'fa-sort-down',
              is:'fa-sort'
          },

					filterByColumn: false,
					filterable: false,

					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					pagination: {
						chunk: 5
					},

					skin: 'table is-striped is-hoverable is-fullwidth',

					templates: {

					},

				}
			}

		}
	},

	computed: {

	},

	watch: {

	},

	created() {

		this.fetchData();

	},

	mounted() {

	},


	methods: {

    async uploadAdSuccess(res) {
      // console.log(res);
      // const res = await this.axios.post(this.$config.api + 'equipmentCatalogAd?include=equipmentCatalogAd.asset');
      this.fetchData({isSilent: true});
      this.$notify.open( { content: 'Anzeige wurde erfolgreich hochgeladen!', type: 'success' })
      this.closeModal();
    },

    async fetchData(args=null) {

      this.isLoading = args != null && args.isSilent ? !args.isSilent : true;
      const res = await this.axios.get(this.$config.api + 'equipmentCatalogAd?include=equipmentCatalogAd.asset');
      this.table.tblData = res.data.equipmentCatalogAd;
      this.isLoading = false;

    },

    async changeStatusAd(row) {

      let ad = this.table.tblData.find((ad) => ad.id == row.id);
      this.$set(ad, 'isLoading', true);
      ad.isActive = !ad.isActive;

      const res = await this.entityCreateOrUpdate('equipmentCatalogAd', ad);

      this.$set(ad, 'isLoading', false);
      // this.$notify.open( { content: 'Status erfolgreich geändert', type: 'success' })
    },


    uploadAd() {

        this.showModal = true;
        this.modal.isLoading = true;
        this.modal.title = 'Neue Anzeige hochladen';
        this.modal.type = 'upload';
        this.modal.class = "modalUploadImages vcenter";

    },


    saveAd() {


    },

		async deleteAd(row) {

      let id = row.id;

      const res = await this.entityDelete('equipmentCatalogAd', id, 'EQUIPMENT_ADD-MSG-CONFIRM_DELETION');
      let adIndex = this.table.tblData.findIndex((ad) => ad.id == id);
      this.table.tblData.splice(adIndex, 1);

		},

		getImagePath(asset) {

			if(asset != null) {
				return this.$config.assets + asset.path + '/' + asset.filename;
			}

			return "";

		},

    closeModal() {
        this.showModal = false;
        this.modalIsSaving = false;
        this.uploadedAds = [];

        // make sure to clear the dropzone
        this.$refs.dzImagePool.$children[0].removeAllFiles();

    },


	}

}
</script>

<style scoped lang="scss">

    // @import '../../assets/css/variables.scss';

		::v-deep table.VueTables__table {
			table-layout: fixed;
			overflow: unset !important;

			thead {
        /*
				position: sticky;
				top: 0;
				z-index: 9;
				background: #FFF;
				box-shadow: 0 1px 1px -1px rgb(0 0 0 / 40%);
        */
				th {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					max-width: 500px;

          &#VueTables_th--status {
            width: 100px;
          }
          &#VueTables_th--actions {
            width: 80px;
            text-align: center;
          }
				}
			}

      td {

        &:last-child {
          text-align: center;
        }
        div.imgWrapper {
          background-repeat: no-repeat;
          background-position: 50% 50% !important;
          background-size: 100%;
          width: 100px;
          height: 150px;
          margin: 0;
          background-color: #FFF;
          border: 1px solid #efefef;
          border-radius: 2px;
        }
        div.imgWrapper[lazy=loading]  {
          background-size: 30% !important;
        }
      }
		}

</style>
